<!--app-toaster-container></app-toaster-container-->
<div class="clearfix"></div>
<div class="container-fluid px-0">
  <div class="main-row">
    <main role="main" class="ml-sm-auto p-0 bg-light main-container">
      <nav class="navbar navbar-light bg-white border border-right-0 border-top-0 text-right">
        <div class="col-md-12">
          <div class="col-md-1" style="float:right">
        <span id="list_toggle" class="style-view" (click)="shouldShowcolumn = !shouldShowcolumn">
          <!--img [ngClass]="{'listicon': shouldShowcolumn, 'columnicon': !shouldShowcolumn}"/-->
          <img *ngIf="shouldShowcolumn" src="{{imgdynamicurl}}/assets/img/col-icon.png"/>
          <img *ngIf="!shouldShowcolumn" src="{{imgdynamicurl}}/assets/img/list-icon.png"/>
          <!--i class="las la-list"
            [ngClass]="{'la-list': shouldShowcolumn, 'la-border-all': !shouldShowcolumn}"></i-->
          </span>
          </div>
          <div class="col-md-11">
            <marquee scrolldelay="200" style="width: 100%;">
              All DEWA applications will be available for access through this portal in the future. Applications will be added here in phases.
              <!-- {{'MENU.MARQUEE' | translate}} -->
            </marquee>
          </div>
        </div>
      </nav>
      <div class="main-content container-fluid scrollcontainer">        
        <div *ngIf="recentinfolist.length==0 && showrecentinfo" class="row">
          <div class="col-lg-12">
              <h4 class="font-weight-bold text-lightdark my-3">Recently Used</h4>
              <h5 class="font-weight-light text-lightdark my-3">No recent activity</h5>
          </div>
      </div>
      <div class="row justify-content-md-center">
        <img [hidden]="!imageLoader" src="{{imgdynamicurl}}/assets//img/loader.gif" style="width:100px;height:100px"/>
      </div>

        <div *ngFor ="let recentinfo of recentinfolist" >
        <div class="row">
          <div class="col mb-3">
            <h4 class="font-weight-bold text-lightdark my-3">Recently Used</h4>
          </div>
        </div>
        
        <!--Recently Used-->
        <div class="row approval-home-links row-cols-1 row-cols-md-5 g-4 mt-3 row-cols-md-1"
          [ngClass]="{'row-cols-md-1': shouldShowcolumn, 'row-cols-md-5': !shouldShowcolumn}">

          <div *ngFor="let appln of recentinfo.applicationInfo.slice(0, 5)" class="col mb-3">
            <div class="card" [ngClass]="{'h-60':!shouldShowcolumn,'h-90':shouldShowcolumn}" style="cursor:pointer">
              <!--img class="approval-icon" (click)="openapp(appln)" src="../../iam/assets/img/fa.png"-->
              <!--div class="card-overlay rounded">
                <span>Coming Soon</span-->
              <div class="card-body rounded" [ngClass]="{'card1':shouldShowcolumn,'card2':!shouldShowcolumn}" (click)="openapp(appln)">
                <!--img src="../../mw/assets//img/arrow.png" class="card-img-bottom" alt="..."-->
                <div class="card-title mb-0 text-truncate" style="font-size:19px">{{appln.applnname}}<img *ngIf="shouldShowcolumn" [ngClass]="{'card-image': !shouldShowcolumn, 'card-image-list': shouldShowcolumn}" (click)="openapp(appln)" src="{{imgdynamicurl}}/assets//img/arrow.png"/></div>
                <!--img class= "card-subtitle mb-2 text-muted" (click)="openapp(appln)" src="../../mw/assets//img/arrow.png"/-->
                <img *ngIf="!shouldShowcolumn" class="card-image" (click)="openapp(appln)" src="{{imgdynamicurl}}/assets//img/arrow.png"/>
                <!--div class="col-md-1">
                  <img class= "card-subtitle mb-2 text-muted" (click)="openapp(appln)" src="..//mw/assets//img/arrow.png">
                </div-->
              </div> 
              <!--/div-->             
            </div>
          </div>
        </div>
        </div>

        <div *ngFor ="let sectioninfo of usersectionInfoList">
        <div class="row">
          <div class="col mb-3">
            <h4 class="text-lightdark mt-2 float-left">{{sectioninfo.sectionName}}</h4>
            <a type="button" class="text-nowrap mt-2" style="padding-left:10px" data-toggle="modal" (click)="EditSection(sectioninfo)" data-target="#add-department">
            <!--a type="button" class="text-nowrap mt-5 float-right" data-toggle="modal" (click)="EditSection(sectioninfo)" data-target="#add-department"-->
              <!--img src="../../mw/assets//img/add-dark.png" height="24" class="mr-3"-->
              <i class="fa fa-edit text-lightdark editiconclass"></i>
            </a>
          </div>
        </div>

        <div class="row approval-home-links row-cols-1 row-cols-md-5 g-4 mt-3 row-cols-md-1"
          [ngClass]="{'row-cols-md-1': shouldShowcolumn, 'row-cols-md-5': !shouldShowcolumn}">
          <div *ngFor="let appln of sectioninfo.applicationInfo" class="col mb-3">
            <a href="{{appln.applnurl}}" target="_blank">
            <div class="card" [ngClass]="{'h-60':!shouldShowcolumn,'h-90':shouldShowcolumn}" style="cursor:pointer">
              <!--img class="approval-icon" src="../../iam/assets/img/fa.png" (click)="addToRecent(appln)"-->
             <!--div class="card-overlay">
               <span>Coming Soon</span-->
               <div class="card-body" (click)="addToRecentItem(appln)" [ngClass]="{'card1':shouldShowcolumn,'card2':!shouldShowcolumn}">
                <!--h5 class="card-title mb-0"><a (click)="addToRecent(appln)">{{appln.applnname}}</a></h5-->
                <div class="card-title mb-0 text-truncate" style="font-size:19px">{{appln.applnname}}
                  <img *ngIf="shouldShowcolumn" [ngClass]="{'card-image': !shouldShowcolumn, 'card-image-list': shouldShowcolumn}" (click)="addToRecent1(appln)" src="../../mw/assets///img/arrow.png"/>
                </div>
                <!--img class= "card-subtitle mb-2 text-muted" (click)="openapp(appln)" src="../../mw/assets///img/arrow.png"/-->
                <img *ngIf="!shouldShowcolumn" class="card-image" (click)="addToRecent1(appln)" src="{{imgdynamicurl}}/assets//img/arrow.png"/>
              </div>
             <!--/div-->
            </div>
          </a>
          </div>        
          </div>

        </div>
          <!--User Application List Sectionwise-->
          <!--div *ngIf="usersectionInfoList.length==0 && showusersection" class="row"-->
          <div class="row">
            <div class="col mb-3">
              <h4 class="font-weight-bold text-lightdark mt-2">
                <!-- {{'MENU.LINE1_SUB' | translate}} -->
                Add Section
                <a type="button"(click)="EditSection(null)" class="text-nowrap mt-2 " data-toggle="modal" data-target="#add-department">
                <img src="{{imgdynamicurl}}/assets//img/add-dark.png" height="24" class="mr-3" style="padding-left:10px"> 
                  </a>
                </h4>
                <h5 class="font-weight-light text-lightdark my-3">
                  You can create your own section with personalised items
                  <!-- {{'MENU.SUB_SEC_DESC' | translate}} -->
                
                </h5>
              <br>
            </div>
        </div>
        
        <div style="display:none">
          <div *ngIf="popupdata1.length!=0" class="row">
            <div class="col mb-3">
              <h4 class="font-weight-bold text-lightdark my-3">All Applications</h4>
            </div>
          </div>
          <div class="row approval-home-links row-cols-1 row-cols-md-5 g-4 mt-3 row-cols-md-1"
            [ngClass]="{'row-cols-md-1': shouldShowcolumn, 'row-cols-md-5': !shouldShowcolumn}">
            <div *ngFor="let appln of popupdata1" class="col mb-3">
              <div class="card h-100" style="cursor:pointer">
                <!--img class="approval-icon" (click)="addToRecent(appln)" src="../../iam/assets/img/fa.png"-->
                <div class="card-body" (click)="addToRecent(appln)">
                  <!--h5 class="card-title mb-0"><a (click)="addToRecent(appln)">{{appln.applnname}}</a></h5-->
                  <h5 class="card-title mb-0 text-truncate">{{appln.applnname}}<img *ngIf="shouldShowcolumn" [ngClass]="{'card-image': !shouldShowcolumn, 'card-image-list': shouldShowcolumn}" (click)="addToRecent(appln)" src="{{imgdynamicurl}}/assets//img/arrow.png"/></h5>                
                <img *ngIf="!shouldShowcolumn" class="card-image" (click)="addToRecent(appln)" src="{{imgdynamicurl}}/assets/img/arrow.png"/>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--- footer section-->
        <footer *ngIf="!imageLoader" style="width:100%;position: fixed; bottom: 4px;margin-left: -19px;margin-right: -15px;margin-bottom: -10px;margin-top: -15px;padding-bottom:10px!important;">
          <div class="row">
            <div class="col-md-11">

              <!--p class="pull-left"-->
             
              © 2023 Dubai Electricity and Water Authority. All Rights Reserved. The site is best viewed using IE 11 and above, Mozilla Firefox, Safari and Chrome.
              <!--/p-->
            </div>
            <!--div class="col pull-right"-->
              <!--p class="pull-right"-->
                <!--version1.0-->
              <!--/p-->
            <!--/div-->
          </div>
          <!--div class="clearfix"></div-->
        </footer>
      </div>
    </main>
  </div>
</div>

<!------------------------Add Department--------------------------------------------->
  <div class="modal fade" id="add-department" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" style="display:none">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable text-body">
      <div class="modal-content">
        <div class="modal-header border-0">
          <h5 class="modal-title" id="exampleModalLabel">{{editSectionname}}</h5>
          <button type="button" class="close" data-dismiss="modal" #closeBtn aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!--form name="sectionform" (ngSubmit)="sectionform.form.valid && onSubmit(sectionform,'')" id="sectionform" #sectionform="ngForm"-->
        <form name="sectionform" id="sectionform" #sectionform="ngForm">
          <div class="modal-body">
            <!--div *ngIf="usersectionInfoList.length==0 && showusersection" class="row">
              <div class="form-group">
              <label for="newsectionname">Section Name</label>
                <input pInputText type="text" 
                placeholder="Enter section name" class="form-control bg-light border-0 pl-5" [(ngModel)]="newsectionname" name="newsectionname" style="height: 30px;"/></div>
              </div-->
              <!--div *ngIf="usersectionInfoList.length==0 && showusersection" class="form-group search"-->
              <div class="form-group search">
                <label for="sectiontitle" class="modal-label col-sm-3 col-form-label" style="display:none">Section Name</label>
                <div class="col-sm-12">
                  <input pInputText type="text"
                  [ngClass]="{'is-invalid': sectionform.submitted && sectionformvalue.length==0}"
                   id="sectionname" required placeholder="Enter Section Name" maxlength="50" class="form-control bg-light border-0" [(ngModel)]="sectiontitle" name="sectiontitle"/>
                  <div *ngIf="sectionform.submitted&&sectionformvalue.length==0" class="invalid-feedback">
                    <div *ngIf="sectionform.submitted&&sectionformvalue.length==0">Please enter Section Name</div>
                  </div>
                </div>
              </div>
              <div *ngIf="usersectionInfoList.length==0 && showusersection">
              <br/><br/></div>
            <div class="form-group search col-sm-12"style="padding:10px">
              <button class="border-0 bg-transparent pl-3">
                <svg width="16px" height="16px" viewBox="0 0 16 16" class="bi bi-search" fill="#717173"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z">
                  </path>
                  <path fill-rule="evenodd"
                    d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z">
                  </path>
                </svg>
              </button>
              <input type="text" class="form-control bg-light border-0 pl-5" id="inputTilename" [(ngModel)]="txtFilter"
                name="inputTilename" placeholder="Search...">
            </div>
            <div class="form-group">              
              <div class="col-lg-12 col-sm-12">
                <img *ngIf="usersectionInfoList.length!=0" [hidden]="!popupimageLoader" src="{{imgdynamicurl}}/assets/img/loader.gif" style="width:50px;align-items: center;"/>
                <ul class="list-group list-group-popup">
                  <li
                    *ngFor="let app of popupdata1 | appfilter:txtFilter"
                    class="list-group-item">
                    <!--span class="appitemspan">{{app.applnname}}</span> <input title="toggle all" type="checkbox"
                      [checked]="app.checked" [(ngModel)]="app.checked" class="all pull-right" [ngModelOptions]="{standalone: true}"-->
                      <span class="appitemspan">{{app.applnname}}</span>
                      <div class="pretty p-svg p-curve all pull-right">
                      <input title="toggle all" type="checkbox"
                      [checked]="app.checked" [(ngModel)]="app.checked" class="all pull-right" [ngModelOptions]="{standalone: true}">
                        <div class="state p-success">
                            <!-- svg path -->
                            <svg class="svg svg-icon" viewBox="0 0 20 20">
                                <path d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z" style="stroke: white;fill:white;"></path>
                            </svg>
                            <label></label>
                        </div>
                    </div>
                  </li>
                </ul>
                <!--pagination-controls style="margin-top:5px;padding:5px;text-align:center;" (pageChange)="p = $event">
                </pagination-controls-->
              </div>
            </div>
          </div>
          <div class="modal-footer border-0">            
            <!--Display only when Edit section and not when adding new section-->
            <!--input *ngIf="usersectionInfoList.length!=0" type="button" class="btn btn-white border" (click)="RemoveSection()" value="Remove Section"/>
            <button *ngIf="usersectionInfoList.length!=0" type="submit" class="btn btn-primary" style="width:150px" (click)="onSubmit(sectionform,'editsection')">Save</button>
            <button *ngIf="usersectionInfoList.length==0 && showusersection" type="submit" style="width:150px" class="btn btn-primary" (click)="onSubmit(sectionform,'addsection')">Save</button-->
            <input *ngIf="editSectionname!='Add Section'" type="button" class="btn btn-white border" (click)="RemoveSection()" value="Remove Section"/>
            <button *ngIf="editSectionname!='Add Section'" type="submit" class="btn btn-primary" style="width:150px" (click)="onSubmit(sectionform,'editsection')">Save</button>
            <button *ngIf="editSectionname=='Add Section'" type="submit" style="width:150px" class="btn btn-primary" (click)="onSubmit(sectionform,'addsection')">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>